class CanvasObject {
    constructor(context) {
        this.context = context;
        this.uid = '<uid>';
        this.selected = false;
        this.editing = false;
        this.hovered = false;
        this.dragging = false;
        this.resizing = false;
        this.position = {
            x: 0,
            y: 0
        };
        this.dimensions = {
            width: 0,
            height: 0
        };
        this.edge = {
            width: 10
        };

        this.init();
    }
    _generateObjectID() {
        const getRandomBytes = (len) => {
            if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
                const arr = new Uint8Array(len);
                crypto.getRandomValues(arr);
                return arr;
            }

            const arr = new Uint8Array(len);
            for (let i = 0; i < len; i++) arr[i] = Math.floor(Math.random() * 256);
            return arr;
        };

        const bytes = getRandomBytes(48);
        let b64 = '';
        if (typeof Buffer !== 'undefined' && typeof Buffer.from === 'function') {
            b64 = Buffer.from(bytes).toString('base64');
        } else {
            let binary = '';
            for (let i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i]);
            b64 = btoa(binary);
        }
        const b64url = b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');

        const id = b64url.padEnd(64, '0').slice(0, 64);
        this.uid = id;
        return id;
    }
    _objectEvents() {
        this.context.canvas.addEventListener('creator:object:mousedown', (event)=>{
            console.log(event);
        });
    }
    _cursorInBounds({ x, y } = {}){
        const rect = this._getObjectBoundingRect();
        if (!rect) return false;

        const he = this.edge.width / 2;

        const rx = rect.x + he ?? 0;
        const ry = rect.y + he ?? 0;
        const rw = rect.width - he * 2 ?? 0;
        const rh = rect.height - he * 2 ?? 0;

        if (rw <= 0 || rh <= 0) return false;

        return (x >= rx && x <= rx + rw && y >= ry && y <= ry + rh);
    }
    _cursorInResizeBounds({ x, y } = {}) {
        const rect = this._getObjectBoundingRect();
        if (!rect) return false;

        // this.edge.width
        // edges
        const he = this.edge.width / 2;

        const rx = rect.x ?? 0;
        const ry = rect.y ?? 0;
        const rw = rect.width ?? 0;
        const rh = rect.height ?? 0;
   
        const bounds = {
            edges: {
                left: x >= (rx - he) && x <= (rx + he) && y > (ry + he) && y < (ry + rh - he),
                right: x >= (rx + rw - he) && x <= (rx + rw + he) && y > (ry + he) && y < (ry + rh - he),
                top: y >= (ry - he) && y < (ry + he) && x > (rx + he) && x < (rx + rw - he),
                bottom: y >= (ry + rh - he) && y < (ry + rh + he) && x > (rx + he) && x < (rx + rw - he),
            },
            corners: {
                top: {
                    left: x >= (rx - he) && x < (rx + he) && y >= (ry - he) && y < (ry + he),
                    right: x > (rx + rw - he) && x <= (rx + rw + he) && y >= (ry - he) && y < (ry + he),
                },
                bottom: {
                    left: x >= (rx - he) && x < (rx + he) && y > (ry + rh - he) && y <= (ry + rh + he),
                    right: x > (rx + rw - he) && x <= (rx + rw + he) && y > (ry + rh - he) && y < (ry + rh + he)
                }
            }
        }

        let boundary = null;

        // return bounds that are true, else return false
        Object.keys(bounds.edges).forEach( edge => {
            if( !bounds.edges[edge] ) return;
            boundary = {
                name: edge,
                type: 'edge'
            }
        } );
        Object.keys(bounds.corners.top).forEach( corner => {
            if( !bounds.corners.top[corner] ) return;
            boundary = {
                name: corner,
                type: 'top.corner'
            };
        } );
        Object.keys(bounds.corners.bottom).forEach( corner => {
            if( !bounds.corners.bottom[corner] ) return;
            boundary = {
                name: corner,
                type: 'bottom.corner'
            };
        } );

        return boundary;
    }
    _objectEdges() {
        const rect = this._getObjectBoundingRect();
        if (!rect) return null;

        return {
            left: rect.x,
            right: rect.x + rect.width,
            top: rect.y,
            bottom: rect.y + rect.height
        };
    }
    _objectUiInfo() {
        const boundingRect = this.boundingRect;
        const ctx = this.context;

        ctx.strokeStyle = 'blue';
        ctx.lineWidth = 5;
        ctx.fillStyle = 'red';
        ctx.font = '14px Inter';

        ctx.fillText(`${Math.round(this.dimensions.width)} x ${Math.round(this.dimensions.height)}`, boundingRect.x, boundingRect.y - 10);

        // ctx.measureText("Object Name").width
        ctx.fillText(`"${this.name}"`, boundingRect.x + boundingRect.width - 10 - ctx.measureText("Object Name").width, boundingRect.y - 10);
    }
    init(){
        this.context.canvas.dispatchEvent(new CustomEvent('creator:object:create', {detail: {object: this}}));
        this.context.canvas.addEventListener('creator:object:edit:finish', (event) => {
            this.editing = false;
            this.selected = false;

            this.context.canvas.dispatchEvent(new CustomEvent('creator:object:update', 
                {
                    detail: {
                        context: this.context,
                        object: this
                    }
                }
            ));
        });
        
        this._generateObjectID();
        this._objectEvents();
    }
    showSelected() {
        const boundingRect = this.boundingRect;

        const ctx = this.context;

        ctx.strokeStyle = 'blue';
        ctx.lineWidth = 2;

        ctx.strokeRect(boundingRect.x, boundingRect.y, boundingRect.width, boundingRect.height);

        this._objectUiInfo();
    }
    showHover() {
        const boundingRect = this.boundingRect;

        const ctx = this.context;

        ctx.strokeStyle = 'blue';
        ctx.lineWidth = 2;

        ctx.strokeRect(boundingRect.x, boundingRect.y, boundingRect.width, boundingRect.height);

        // this._objectUiInfo();
    }
    destroy() {
        this.context.canvas.dispatchEvent(new CustomEvent('creator:object:destroy', {detail: {object: this}}));
    }
}

export {
    CanvasObject
}
